import { render, staticRenderFns } from "./SourceInfo.vue?vue&type=template&id=67ce635a&scoped=true"
import script from "./SourceInfo.vue?vue&type=script&lang=js"
export * from "./SourceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce635a",
  null
  
)

export default component.exports